const REGEX_OPERATORS = /[|\\{}()[\]^$+*?.]/g

export const prepareSearchTerm = (term: string) => term.replace(REGEX_OPERATORS, '\\$&')

export const prepareSearchRegex = (term: string) => new RegExp(prepareSearchTerm(term), 'i')

export const prepareSearchPhoneNumber = (value: string) => value.replace(/[()+-\s]/g, '')
